"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var useDealers_1 = require("../../../../commonSteps/dealer/hooks/useDealers");
var dealerSummaryStyles_1 = require("./dealerSummaryStyles");
var useCheckoutContext_1 = require("../../../../common/hooks/useCheckoutContext");
var DealerPageInfo_1 = require("../../../../commonSteps/dealer/components/dealerPageInfo/DealerPageInfo");
var DealerSummary = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var deal = useCheckoutContext_1.default().deal;
    var dealerId = (_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.dealer) === null || _b === void 0 ? void 0 : _b.externalId;
    var data = useDealers_1.useDealers().data;
    var dealers = (_d = (_c = data) === null || _c === void 0 ? void 0 : _c.dealers) === null || _d === void 0 ? void 0 : _d.nodes;
    var currentDealer = (_e = dealers) === null || _e === void 0 ? void 0 : _e.find(function (_a) {
        var externalId = _a.externalId;
        return externalId === dealerId;
    });
    var styles = dealerSummaryStyles_1.default();
    var isStock = useCheckoutContext_1.default().isStock;
    if (!currentDealer) {
        return null;
    }
    return (<core_1.Box className={styles.dealerSummary} data-test="checkout:dealer:summary">
      {isStock && <DealerPageInfo_1.default />}
      <core_1.Typography variant="subtitle2" className={styles.dealerName} data-test="checkout:dealer:name">
        {currentDealer.label}
      </core_1.Typography>
      <core_1.Box className={styles.dealerAddress}>
        <core_1.Typography className={styles.dealerItem} variant="body2" component="div" data-test="checkout:dealer:streetName">
          {(_f = currentDealer.address) === null || _f === void 0 ? void 0 : _f.address}
        </core_1.Typography>
        <core_1.Typography className={styles.dealerItem} variant="body2" component="div" data-test="checkout:dealer:city">
          {(_g = currentDealer.address) === null || _g === void 0 ? void 0 : _g.city}
        </core_1.Typography>
      </core_1.Box>
    </core_1.Box>);
};
exports.default = DealerSummary;
